const nonNegativeInteger = (value) => Number.isInteger(value) && Number(value) >= 0;
export function isMemberImportDiagnosticResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return (typeof item.fileName === 'string' &&
        (item.extension === '.xlsx' || item.extension === '.xlsm') &&
        nonNegativeInteger(item.sizeBytes) &&
        typeof item.sha256 === 'string' &&
        /^[0-9a-f]{64}$/.test(item.sha256) &&
        typeof item.diagnosedAt === 'string' &&
        !Number.isNaN(Date.parse(item.diagnosedAt)) &&
        nonNegativeInteger(item.sheetCount) &&
        nonNegativeInteger(item.tableCount) &&
        nonNegativeInteger(item.emptySheetCount) &&
        Array.isArray(item.sheets) &&
        item.sheets.length === item.sheetCount &&
        item.sheets.every((sheet) => typeof sheet.id === 'string' &&
            Number.isInteger(sheet.position) &&
            sheet.position > 0 &&
            typeof sheet.name === 'string' &&
            ['visible', 'hidden', 'veryHidden'].includes(sheet.visibility) &&
            nonNegativeInteger(sheet.rowCount) &&
            nonNegativeInteger(sheet.columnCount) &&
            nonNegativeInteger(sheet.nonEmptyCellCount) &&
            nonNegativeInteger(sheet.formulaCellCount) &&
            Array.isArray(sheet.tableNames) &&
            sheet.tableNames.every((name) => typeof name === 'string')));
}
